/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-undef */
import {
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import OaLabel from '@orientaction/commons/OaLabel';
import { AdminTestContext } from '@orientaction/Context';
import { forwardRef, useContext, useEffect, useState } from 'react';
import Select from 'react-select';
import CategorySelect from './CategorySelect';
import EnterprisesSelect from './Select/EnterprisesSelect';
import PermissionsSelect from './Select/PermissionsSelect';
import style from './style';
import TestDescription from './TestDescritpion';
import TimeInput from './Time';
import clsx from 'clsx';
import { debounce } from 'lodash';
import CheckCircle from '@material-ui/icons/CheckCircle';
import classNames from 'classnames';

const options = [
  { value: 1, label: 'Données stockées' },
  { value: 0, label: 'Données non-stockées' },
];

const CustomDropdownIndicator = ({ innerRef, innerProps }: any) => (
  <ArrowDropDownIcon innerRef={innerRef} {...innerProps} />
);

const customStyles = (error: boolean, matches: boolean) => {
  return {
    control: (provided: any) => ({
      ...provided,
      borderColor: error ? '#f44336' : '#0E1247',
      height: 43,
      width: matches ? '100%' : '97%',
      boxShadow: 'unset',
      '&:hover': {
        borderColor: error ? '#f44336' : '#0E1247',
      },
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      width: 0,
    }),
  };
};

const VisibilitySection = forwardRef((_, ref: any) => {
  const { timeRef, visibilityRef, testMinMaxValueRef, globalTimerRef } = ref;
  const testContext = useContext<any>(AdminTestContext);
  const { test, updateTest } = testContext;
  const classes = style();
  const { companies } = test;
  const [checkedTimer, setCheckedTimer] = useState<boolean>(false);
  const [timerNumber, setTimeNumber] = useState<number | string | null>(test?.test?.globalTimer);
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [minInterval, setMinInterval] = useState('');
  const [maxInterval, setMaxInterval] = useState('');

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));

  const showEnterpriseSelect =
    !!companies?.length &&
    test?.visibilityPermission &&
    Array.isArray(test.visibilityPermission) &&
    test.visibilityPermission.some((vp: any) => vp.value === 4);

  const showAll =
    !!companies?.length &&
    test?.visibilityPermission &&
    Array.isArray(test.visibilityPermission) &&
    test?.visibilityPermission[0]?.value === 0;
  const showGlobalTimerError = Boolean(test?.test?.useGlobalTimer && test?.errors?.globalTimer);
  const globalTimerErrorText =
    test?.test?.globalTimer === '' ||
    test?.test?.globalTimer === null ||
    typeof test?.test?.globalTimer === 'undefined'
      ? 'Champ obligatoire'
      : 'Minimum 1 seconde';

  const companiesTranformed = (companies || []).map((c: any) => ({
    ...c,
    value: c.id,
    label: c.attributes.name,
  }));

  const handleChange = (selected: any) => {
    updateTest({ test: { ...test.test, stockageMode: selected } });
  };

  const handleChangeCheckBox = (event: any) => {
    updateTest({
      test: { ...test.test, useGlobalTimer: event.target.checked },
      errors: event.target.checked ? test?.errors : { ...test?.errors, globalTimer: false },
    });
  };

  const handleChangeGlobalTimer = (event: any) => {
    const { value } = event.target;
    if ((value === '' || Number(value) >= 0) && value.length <= 4) {
      const hasError = value === '' || Number(value) < 1;
      updateTest({
        test: { ...test.test, globalTimer: value === '' ? '' : Number(value) },
        errors: { ...test?.errors, globalTimer: hasError },
      });
      updateValue(event);
      setTimeNumber(value);
    }
  };

  const updateValue = debounce(async event => {
    const { value } = event.target;
    const questionWithResetedAllTimer = test?.questions.map((q: any) => ({
      ...q,
      timer: null,
    }));
    updateTest({
      test: { ...test.test, globalTimer: value === '' ? '' : Number(value) },
      questions: questionWithResetedAllTimer,
      errors: { ...test?.errors, globalTimer: value === '' || Number(value) < 1 },
    });
    setShowMessage(true);
  }, 2000);

  const styles = customStyles(false, matches);

  useEffect(() => {
    setCheckedTimer(test?.test.useGlobalTimer);
    setTimeNumber(test?.test?.globalTimer ?? null);
  }, [test]);

  useEffect(() => {
    setTimeout(() => {
      setShowMessage(false);
    }, 2000);
  }, [showMessage]);

  const handleMinIntervalValueChange = (e: any) => {
    if (
      parseInt(e.target.value, 10) >= 0 ||
      e.target.value === '' ||
      !isNaN(parseInt(e.target.value, 10))
    ) {
      updateTest({
        test: {
          ...test.test,
          minValueAg: e.target.value === '' ? '' : parseInt(e.target.value, 10),
        },
      });
    }
  };

  const handleMaxIntervalValueChange = (e: any) => {
    if (
      parseInt(e.target.value, 10) >= 0 ||
      e.target.value === '' ||
      !isNaN(parseInt(e.target.value, 10))
    ) {
      updateTest({
        test: {
          ...test.test,
          maxValueAg: e.target.value === '' ? '' : parseInt(e.target.value, 10).toString(),
        },
      });
    }
  };

  return (
    <div>
      <Grid className={classes.marginTop} container={true} spacing={2}>
        <Grid item={true} sm={12} md={6}>
          <OaLabel text="Temps estimé (minutes)" />
          <TimeInput ref={timeRef} />
        </Grid>
        <Grid item={true} sm={12} md={6}>
          <OaLabel text="Limite de temps" />
          <Grid container={true} style={{ position: 'relative' }}>
            <Grid item={true} xs={true} style={{ display: 'flex' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedTimer}
                    color="primary"
                    style={{ padding: 6 }}
                    onChange={handleChangeCheckBox}
                    checkedIcon={<span className={clsx(classes.iconC, classes.checkedIcon)} />}
                    icon={<span className={classes.iconC} />}
                  />
                }
                label={
                  <div className={classes.textTimer}>
                    <div style={{ fontSize: 14, color: '#151528', textWrap: 'nowrap' }}>
                      Activer la limite de temps
                    </div>
                    <div style={{ fontSize: 10, fontFamily: 'Poppins', color: '#E63C3C' }}>
                      Attention : modifier ici la limite formatera les temps personnalisés des
                      questions
                    </div>
                  </div>
                }
              />
            </Grid>
            <Grid item={true} xs={true} style={{ display: 'flex' }} alignItems="center">
              <div ref={globalTimerRef} style={{ display: 'flex', alignItems: 'center' }}>
                <TextField
                  onChange={handleChangeGlobalTimer}
                  name="timer"
                  value={timerNumber ?? ''}
                  type="number"
                  placeholder="30"
                  variant="outlined"
                  required={test?.test?.useGlobalTimer}
                  error={showGlobalTimerError}
                  helperText={showGlobalTimerError ? globalTimerErrorText : ''}
                  inputProps={{ min: 1 }}
                  FormHelperTextProps={{
                    style: { position: 'absolute', top: '100%', marginLeft: 0, whiteSpace: 'nowrap' },
                  }}
                  className={classNames(classes.formInput, showGlobalTimerError && classes.error)}
                />
                <span style={{ fontSize: 11, color: '#151528', marginLeft: 3 }}>secondes</span>
              </div>
              {showMessage && (
                <Typography variant="h5" className={classes.text}>
                  <CheckCircle />
                  Nouveau temps appliqué
                </Typography>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <OaLabel text="Droits de visibilité" />
      <Grid className={classes.marginTop} container={true}>
        <Grid innerRef={visibilityRef} item={true} sm={12} md={6}>
          <PermissionsSelect test={test} updateTest={updateTest} />
        </Grid>
        {showEnterpriseSelect || showAll ? (
          <Grid item={true} sm={12} md={6}>
            <EnterprisesSelect
              companies={companiesTranformed}
              test={test}
              updateTest={updateTest}
            />
          </Grid>
        ) : null}
      </Grid>
      <Grid className={classes.marginTop} container={true}>
        <Grid item={true} sm={12} md={6}>
          <OaLabel>Catégorie par défaut</OaLabel>
          <CategorySelect />
        </Grid>
        <Grid item={true} sm={12} md={6}>
          <OaLabel>Mode de stockage</OaLabel>
          <Select
            styles={styles}
            components={{ DropdownIndicator: CustomDropdownIndicator }}
            placeholder="Sélectionnez"
            className={classes.select}
            options={options}
            value={test?.test?.stockageMode}
            onChange={handleChange}
          />
        </Grid>
        <Grid className={classes.marginTop} container={true}>
          <Grid item={true} xs={true}>
            <OaLabel>Description du test</OaLabel>
            <TestDescription />
          </Grid>
        </Grid>
      </Grid>
      {test?.test?.diagram?.id === 6 && (
        <>
          <div style={{ marginTop: 20, marginBottom: 20, width: '100%' }}>
            <OaLabel>Titre du diagramme</OaLabel>
            <TextField
              id="create-test-diagram-title"
              variant="outlined"
              fullWidth={true}
              name="diagram-title"
              value={test?.test?.diagramTitle || ''}
              onChange={e => updateTest({ test: { ...test.test, diagramTitle: e.target.value } })}
              placeholder="Renseignez le titre"
            />
          </div>
          <div ref={testMinMaxValueRef} className={classNames(classes.marginTop, classes.fullWidth)}>
            <OaLabel>Configuration de l'affichage du diagramme</OaLabel>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div>
                <div className={classes.labelMinMax}>Valeur minimale</div>
                <TextField
                  id="test-min-interval"
                  variant="outlined"
                  className={classNames(
                    classes.formInput,
                    test?.errors?.minValueAg && classes.error
                  )}
                  value={test.test.minValueAg}
                  onChange={handleMinIntervalValueChange}
                  placeholder="Ex : 0"
                  type="number"
                />
              </div>
              <div style={{ marginLeft: 30 }}>
                <div className={classes.labelMinMax}>Valeur maximale</div>
                <TextField
                  id="test-max-interval"
                  variant="outlined"
                  className={classNames(
                    classes.formInput,
                    test?.errors.maxValueAg && classes.error
                  )}
                  value={test.test.maxValueAg}
                  onChange={handleMaxIntervalValueChange}
                  placeholder="Ex : 20"
                  type="number"
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
});

export default VisibilitySection;
